var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "07A52195-85E3-4F2D-8D10-B1914200078B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02---VR-Add-Video",
    transform: "translate(-404.000000, -681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form",
    transform: "translate(150.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close-red",
    transform: "translate(254.000000, 538.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF3B30",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18158311,13.8122479 C6.29866909,13.929593 6.46258948,14 6.62650986,14 C6.79043025,14 6.94264203,13.9413275 7.07143662,13.8122479 L9.99858634,10.8786212 L12.9257361,13.8122479 C13.042822,13.929593 13.2067424,14 13.3706628,14 C13.5345832,14 13.686795,13.9413275 13.8155896,13.8122479 C14.0614701,13.5658232 14.0614701,13.16685 13.8155896,12.9321599 L10.8884399,9.99853319 L13.8155896,7.06490649 C14.0614701,6.81848185 14.0614701,6.41950862 13.8155896,6.18481848 C13.569709,5.93839384 13.1833252,5.93839384 12.9374447,6.18481848 L10.0102949,9.11844518 L7.08314522,6.18481848 C6.83726464,5.93839384 6.45088088,5.93839384 6.2050003,6.18481848 C5.95911973,6.43124312 5.95911973,6.83021635 6.2050003,7.06490649 L9.13215002,9.99853319 L6.2050003,12.9321599 C5.93570253,13.1785845 5.93570253,13.5658232 6.18158311,13.8122479 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.651fb86626698d5a5ad12df5c1cd5361.svg";
export { ForwardRef as ReactComponent };